var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"needs_list"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.toDetail(item)}}},[_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v("截止时间："+_vm._s(item.endDate))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a790190","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/needsList.vue
// module id = null
// module chunks = 